
function clients(state = {}, action) {
    switch(action.type) {
        case 'CLIENTS_FETCH_START' :
            return {
                fetching : true,
                data : {},
                error : null,
            }
        case 'CLIENTS_FETCH_SUCCESS' : 
            const data = action.data;
            data.items = data.data;
            delete data.data;
            return {
                fetching : false,
                data,
                error : null,
            }
        case 'CLIENTS_FETCH_FAILURE' :
            return {
                fetching : false,
                data : {},
                error : action.error
            }
        default :
            return state;
    }
}

export default clients;


/** WEBPACK FOOTER **
 ** ./src/reducers/clients.js
 **/